<template>
  <li :class="classList">
    <template v-if="wrapper && wrapper.element">
      <component :is="wrapper.element" v-bind="wrapper.attributes">
        {{ uniTranslation(name) }}
      </component>
    </template>
    <template v-else>
      {{ uniTranslation(name) }}
    </template>
  </li>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ""
    },
    classes: {
      type: String,
      default: ""
    },
    wrapper: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    classList() {
      return ["nav-title2", ...this.itemClasses];
    },
    itemClasses() {
      return this.classes ? this.classes.split(" ") : "";
    }
  }
};
</script>

<style>
.nav-title2 {
  padding: 0.75rem 1rem;
  font-size: 14px;
  font-weight: 600;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
